import React, { ReactElement, useEffect, useState } from "react";
import Layout from "../layout/layout";
import Image from "next/image";
import advantagesheader from "@/assets/images/adv-header.jpg";
import iconadv from "@/assets/images/icon-adv.jpg";
import skv from "@/assets/images/skv.png";
import s2 from "@/assets/images/s2.png";
import s3 from "@/assets/images/s3.png";
import s4 from "@/assets/images/s4.png";
import s5 from "@/assets/images/s5.png";
import s6 from "@/assets/images/s6.png";
import s7 from "@/assets/images/s7.png";
import s8 from "@/assets/images/s8.png";
import s9 from "@/assets/images/s9.png";
import s10 from "@/assets/images/s10.png";
import s11 from "@/assets/images/s11.png";
import s12 from "@/assets/images/s12.png";
import s13 from "@/assets/images/s13.png";
import s14 from "@/assets/images/s14.png";
import styles from "../styles/franchise.module.scss";
import { wrapper } from "@/store";
import { setMeta, setOg, setPath, setTitle } from "@/store/slices/helmet";
import * as Yup from "yup";
import { useFormik } from "formik";
import { phoneRegExp } from "@/utils/regex";
import { Spinner } from "react-bootstrap";
import { state } from "@/data/state";
import httpClient from "@/api/http-client";
import endpoints from "@/api/endpoints";
import { toast } from "react-toastify";

const Franchise = () => {
  const [loading, setLoading] = useState(false);
  const [showfrom, setshowfrom] = useState(true);
  const [idType, setIdType] = useState(["PAN", "Aadhaar", "Passport"]);
  const [state, setState] = useState<any>([]);

  const formik = useFormik({
    initialValues: {
      name: "",
      mobile: "",
      email: "",
      location: "",
      state: "",
      present_address: "",
      // nri: "",
      id_number: "",
      id_type: "",
      current_business: "",
      turnover: "",
      capacity: "",
      mode: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      mobile: Yup.string()
        .matches(phoneRegExp, "Mobile number is not valid")
        .test(
          "len",
          "Mobile number needs to be exactly 10 digits",
          (val: any) => val?.toString().length === 10
        )
        .required("Required"),
      email: Yup.string()
        .email("Invalid email format")
        .required(" Email is Required"),
      location: Yup.string().required("Preferred Location is required"),
      state: Yup.string().required("State is required"),
      present_address: Yup.string().required("Present Address is required"),
      current_business: Yup.string().required(
        "Nature of Current Business is required"
      ),
      id_number: Yup.string().required("Id Number is required"),
      id_type: Yup.string().required("Id Type is required"),

      turnover: Yup.string().required("Yearly Turnover is required"),
      capacity: Yup.string().required("Investment Capacity is required"),
      mode: Yup.string().required("Mode of Investment is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const { data } = await httpClient.post(
          endpoints.franchiseEnquiry(),
          values,
          {
            headers: { Accept: "application/json" },
          }
        );
        if (data.status) {
          setshowfrom(false);
        } else {
          toast("Mobile or Email is already taken!", {
            type: "error",
            toastId: "condition-err",
          });
        }
      } catch (error: any) {}
      setLoading(false);
    },
  });
  const stateLoad = async (country: any) => {
    const { data } = await httpClient.get(endpoints.state(country));
    setState(data.data);
  };
  useEffect(() => {
    stateLoad("IND");
  }, []);

  return (
    <>
      <div className={styles.franchise_banner}>
        <Image
          src={require("@/assets/images/banner-s.jpg")}
          className="img-fluid"
          alt=""
        />
      </div>
      <div className={styles.franchise_main}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10">
              <h2>Inviting Franchise Partners</h2>
              <p>
                Come, become a part of the Senco family- to the world of design
                and karigari and a part of one of the most trusted brands in the
                country. With our origins in Calcutta, the land of Art, Culture
                and Craftsmanship, and a legacy of more than 50 years, with 150+
                stores across the country, be a partner, and the chosen one for
                carrying the legacy in your geography.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.franchise_form}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <p className={styles.text_head}>
                To be part of the amazing world of designs and karigari, kindly
                fill in your personal &amp; business information which is
                essential for further processing of your application.
              </p>
            </div>
            <div className="col-md-12">
              <div className={styles.franchise_form_main}>
                <aside>
                  {showfrom ? (
                    <form onSubmit={formik.handleSubmit}>
                      <div className="row">
                        <div className="col-md-12">
                          <h3>Personal Details</h3>
                          <div className="row ">
                            <div className="col-md-3">
                              <div className="mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Name"
                                  {...formik.getFieldProps("name")}
                                />
                                {formik.touched.name && formik.errors.name ? (
                                  <small className="text-danger">
                                    {formik.errors.name}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Mobile Number"
                                  {...formik.getFieldProps("mobile")}
                                />
                                {formik.touched.mobile &&
                                formik.errors.mobile ? (
                                  <small className="text-danger">
                                    {formik.errors.mobile}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="mb-3">
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="Email ID"
                                  {...formik.getFieldProps("email")}
                                />
                                {formik.touched.email && formik.errors.email ? (
                                  <small className="text-danger">
                                    {formik.errors.email}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Preferred Location"
                                  {...formik.getFieldProps("location")}
                                />
                                {formik.touched.location &&
                                formik.errors.location ? (
                                  <small className="text-danger">
                                    {formik.errors.location}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="mb-3">
                                <select
                                  className="form-select"
                                  {...formik.getFieldProps("state")}
                                >
                                  <option value="" disabled>
                                    Select state
                                  </option>
                                  {!!state.length &&
                                    state.map((v: any) => (
                                      <option value={v.code} key={v.code}>
                                        {v.name}
                                      </option>
                                    ))}
                                </select>
                                {formik.touched.state && formik.errors.state ? (
                                  <small className="text-danger">
                                    {formik.errors.state}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-md-9">
                              <div className="mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Present Address"
                                  {...formik.getFieldProps("present_address")}
                                />
                                {formik.touched.present_address &&
                                formik.errors.present_address ? (
                                  <small className="text-danger">
                                    {formik.errors.present_address}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <select
                                  className="form-select"
                                  {...formik.getFieldProps("id_type")}
                                >
                                  <option value="" disabled>
                                    Select Id type
                                  </option>
                                  {idType.map((v) => (
                                    <option key={v} value={v}>
                                      {v}
                                    </option>
                                  ))}
                                </select>
                                {formik.touched.id_type &&
                                formik.errors.id_type ? (
                                  <small className="text-danger">
                                    {formik.errors.id_type}
                                  </small>
                                ) : null}{" "}
                              </div>{" "}
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Id Number"
                                  {...formik.getFieldProps("id_number")}
                                />
                                {formik.touched.id_number &&
                                formik.errors.id_number ? (
                                  <small className="text-danger">
                                    {formik.errors.id_number}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <h3>Financial Details</h3>
                          <div className="row justify-content-center">
                            <div className="col-md-6">
                              <div className="mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Nature of Current Business"
                                  {...formik.getFieldProps("current_business")}
                                />
                                {formik.touched.current_business &&
                                formik.errors.current_business ? (
                                  <small className="text-danger">
                                    {formik.errors.current_business}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Yearly Turnover (in crore)"
                                  {...formik.getFieldProps("turnover")}
                                />
                                {formik.touched.turnover &&
                                formik.errors.turnover ? (
                                  <small className="text-danger">
                                    {formik.errors.turnover}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-md-6 mb-3">
                              <div className="d-block mb-1">
                                <label>Investment capacity</label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="capacity"
                                  value="5 cr. – 10 cr."
                                  checked={
                                    formik.values.capacity === "5 cr. – 10 cr."
                                  }
                                  onChange={formik.handleChange}
                                  id="5-20"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="5-10"
                                >
                                  5 cr. – 10 cr.
                                </label>
                              </div>{" "}
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="capacity"
                                  value="10 cr. – 15 cr."
                                  checked={
                                    formik.values.capacity === "10 cr. – 15 cr."
                                  }
                                  onChange={formik.handleChange}
                                  id="5-20"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="5-10"
                                >
                                  10 cr. – 15 cr.
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="capacity"
                                  value="15 cr. - 20 cr."
                                  checked={
                                    formik.values.capacity === "15 cr. - 20 cr."
                                  }
                                  onChange={formik.handleChange}
                                  id="5-20"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="5-10"
                                >
                                  15 cr. - 20 cr.
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="capacity"
                                  value="20 cr. - 25 cr."
                                  checked={
                                    formik.values.capacity === "20 cr. - 25 cr."
                                  }
                                  onChange={formik.handleChange}
                                  id="20-25"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="12-20"
                                >
                                  20 cr. - 25 cr.
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="capacity"
                                  value="Above 25 cr."
                                  checked={
                                    formik.values.capacity === "Above 25 cr."
                                  }
                                  onChange={formik.handleChange}
                                  id="above-25"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="above-25"
                                >
                                  Above 25 cr.
                                </label>
                              </div>
                              <div className="d-block">
                                {formik.touched.capacity &&
                                formik.errors.capacity ? (
                                  <small className="text-danger">
                                    {formik.errors.capacity}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-md-6 mb-3">
                              <div className="d-block mb-1">
                                <label>Mode of Investment</label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="mode"
                                  value="Own Equity"
                                  checked={formik.values.mode === "Own Equity"}
                                  onChange={formik.handleChange}
                                  id="Own Equity"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="Own Equity"
                                >
                                  Own Equity
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="mode"
                                  value="Bank Loan"
                                  checked={formik.values.mode === "Bank Loan"}
                                  onChange={formik.handleChange}
                                  id="Bank Loan"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="Bank Loan"
                                >
                                  Bank Loan
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="mode"
                                  value="Both"
                                  checked={formik.values.mode === "Both"}
                                  onChange={formik.handleChange}
                                  id="Both"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="Both"
                                >
                                  Both
                                </label>
                              </div>
                              <div className="d-block">
                                {formik.touched.mode && formik.errors.mode ? (
                                  <small className="text-danger">
                                    {formik.errors.mode}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-12 col-md-3 mt-2">
                              <button
                                role="button"
                                aria-label="Submit Button"
                                type="submit"
                                disabled={loading}
                              >
                                SUBMIT
                                {loading && (
                                  <Spinner
                                    style={{
                                      fontSize: 6,
                                      height: 20,
                                      width: 20,
                                    }}
                                    animation="border"
                                  />
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className="container text-center">
                      <Image
                        src="https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/NKtVOOFi4KwaQdtarq7IMyx9NIzG68QeHZkU6l1j.png"
                        alt="offer image"
                        width={120}
                        height={120}
                      />

                      <h1 className="mb-4">Thank You!</h1>
                      <p className="text-center">
                        The form was submitted successfully.
                      </p>
                    </div>
                  )}
                </aside>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.five_star_container_desktop}>
        <div className="container">
          <div className={styles.advantages_main}>
            <div className={styles.advantages_main_header}>
              <Image src={advantagesheader} alt="" />
            </div>
            <div className={styles.advantages_main_body}>
              <div className="row">
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>OVER 8 DECADES OF LEGACY</h4>
                      <div className={styles.icon_adv}>
                        <Image src={iconadv} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Our Legacy of trust and integrity is built on its
                        ethical business practices and focus on providing
                        customers with the purest of exquisite jewelleries
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>2ND MOST TRUSTED , BRAND</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s2} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        We have won several awards and accolades, including the
                        2nd most trusted brand in the jewellery category in
                        India by TRA{"'"}S Brand Trust Report in 2020, 2021,
                        2022
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>OUR WORLD-CLASS KARIGARI .</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s3} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Our jewelleries are meticulously crafted by our team of
                        karigars, using the traditional skills of world-famous
                        Bengal artistry.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>BIS HALLMARKED PUREST GOLD</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s4} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Rest assured, your Senco gold jewellery is of the
                        highest standard & made of BIS hallmarked gold, so you
                        can shop with confidence.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>RIGHT PRICING</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s5} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        For over 8 decades, millions of connoisseurs trust our
                        guarantee of right pricing on all products with
                        beautiful craftsmanship.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>FREE LIFETIME MAINTENANCE</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s6} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Enjoy the lifelong facility of free servicing for all
                        your Senco jewellery, at any Senco showroom.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>EXCHANGE & BUYBACK GUARANTEE</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s7} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Enjoy 0% deduction on old gold exchange & buyback
                        facility for Senco jewellery, so you can keep changing
                        your style & status quo!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>CERTIFIED GENUINE DIAMONDS</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s8} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        We offer only certified diamonds with buy back
                        guarantee, so you can be sure you{"'"}re buying nothing
                        but the best in the world.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>EARN REWARDING POINTS</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s9} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Earn Loyalty Points with every purchase & enjoy the
                        rewards of added benefits & cashback.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>EMI ON DIAMOND JEWELLERY</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s10} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Buy diamond jewellery now & pay later, with our easy EMI
                        facility, starting from just Rs 5000/month with lower
                        rate of interest.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>RESPONSIBLE JEWELLER</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s11} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        From sourcing materials to caring for our artisans &
                        employees, we maintain the highest standards of ethics,
                        environment-friendly practices & code of conduct
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>INSURED DIAMOND JEWELLERY</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s12} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        We offer free insurance on diamond jewellery, so you can
                        dazzle stress-free!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>OMNI-CHANNEL SERVICE</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s13} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Our omni-channel services allow customers to access our
                        products through a variety of channels, including
                        website, customer care, physical stores, video calls and
                        MySenco mobile app.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-none-mobile-view">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h3>A world of benefits. crafted for you</h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h4>EASY & REWARDING MONTHLY SAVING SCHEME</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s14} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Buy your dream jewellery in small monthly installments
                        with our Swarna Yojana saving scheme, tailored for your
                        convenience and earn more than bank interest.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-none-desktop-view">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center">
                      <h3>A world of benefits. crafted for you</h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className={styles.skv}>
                    <Image src={skv} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.five_star_container_mobile}>
        <div className="container">
          <div className={styles.advantages_main}>
            <div className={styles.advantages_main_header}>
              <Image src={advantagesheader} alt="" />
            </div>
            <div className={styles.advantages_main_body}>
              <div className="row">
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>OVER 8 DECADES OF LEGACY</h4>
                      <div className={styles.icon_adv}>
                        <Image src={iconadv} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Our Legacy of trust and integrity is built on its
                        ethical business practices and focus on providing
                        customers with the purest of exquisite jewelleries
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>2ND MOST TRUSTED , BRAND</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s2} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        We have won several awards and accolades, including the
                        2nd most trusted brand in the jewellery category in
                        India by TRA{"'"}S Brand Trust Report in 2020, 2021,
                        2022
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>OUR WORLD-CLASS KARIGARI .</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s3} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Our jewelleries are meticulously crafted by our team of
                        karigars, using the traditional skills of world-famous
                        Bengal artistry.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>BIS HALLMARKED PUREST GOLD</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s4} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Rest assured, your Senco gold jewellery is of the
                        highest standard & made of BIS hallmarked gold, so you
                        can shop with confidence.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>RIGHT PRICING</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s5} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        For over 8 decades, millions of connoisseurs trust our
                        guarantee of right pricing on all products with
                        beautiful craftsmanship.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>FREE LIFETIME MAINTENANCE</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s6} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Enjoy the lifelong facility of free servicing for all
                        your Senco jewellery, at any Senco showroom.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>EXCHANGE & BUYBACK GUARANTEE</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s7} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Enjoy 0% deduction on old gold exchange & buyback
                        facility for Senco jewellery, so you can keep changing
                        your style & status quo!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>CERTIFIED GENUINE DIAMONDS</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s8} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        We offer only certified diamonds with buy back
                        guarantee, so you can be sure you{"'"}re buying nothing
                        but the best in the world.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>EARN REWARDING POINTS</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s9} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Earn Loyalty Points with every purchase & enjoy the
                        rewards of added benefits & cashback.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>EMI ON DIAMOND JEWELLERY</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s10} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Buy diamond jewellery now & pay later, with our easy EMI
                        facility, starting from just Rs 5000/month with lower
                        rate of interest.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>RESPONSIBLE JEWELLER</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s11} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        From sourcing materials to caring for our artisans &
                        employees, we maintain the highest standards of ethics,
                        environment-friendly practices & code of conduct
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>INSURED DIAMOND JEWELLERY</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s12} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        We offer free insurance on diamond jewellery, so you can
                        dazzle stress-free!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>OMNI-CHANNEL SERVICE</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s13} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Our omni-channel services allow customers to access our
                        products through a variety of channels, including
                        website, customer care, physical stores, video calls and
                        MySenco mobile app.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-none-mobile-view">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h3>A world of benefits. crafted for you</h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h4>EASY & REWARDING MONTHLY SAVING SCHEME</h4>
                      <div className={styles.icon_adv}>
                        <Image src={s14} alt="" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <p>
                        Buy your dream jewellery in small monthly installments
                        with our Swarna Yojana saving scheme, tailored for your
                        convenience and earn more than bank interest.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-none-desktop-view">
                  <div className={styles.card_adv_pad}>
                    <div className="d-flex align-items-center justify-content-space-between">
                      <h3>A world of benefits. crafted for you</h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className={styles.skv}>
                    <Image src={skv} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Franchise.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>;
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ resolvedUrl }) => {
      store.dispatch(setPath(resolvedUrl));
      store.dispatch(setTitle("Franchise Enquiry - Senco Gold and Diamonds"));
      store.dispatch(
        setMeta({
          title: "Franchise Enquiry - Senco Gold and Diamonds",
          description:
            "Senco is inviting franchise partner to become a part of no 1 jewellery store, Senco Gold and Diamonds. Connect with us for any franchise enquiry",
          keywords: "",
        })
      );
      store.dispatch(
        setOg({
          type: "website",
          url: `${process.env.NEXT_PUBLIC_APP_URL}${resolvedUrl}`,
          title: "Franchise Enquiry - Senco Gold and Diamonds",
          description:
            "Senco is inviting franchise partner to become a part of no 1 jewellery store, Senco Gold and Diamonds. Connect with us for any franchise enquiry",
          image: "",
        })
      );
      return {
        props: {},
      };
    }
);

export default Franchise;
